<template>
  <div>
    <Header v-if="tipoPantalla === 1"/>
    <div
        class="p-4"
        style="min-height: 90vh; background-color: white"
        :class="tipoPantalla === 1 ? 'bCardGlobalXL' : 'mt-4 pl-2 pr-2'"
    >
      <div class="divSubtitulo d-flex justify-content-between m-1 mb-3">
        <p class="textoSubtitulo">
          {{
            tipoPantalla === 1
                ? "Ordenes de trabajo"
                : "Ordenes del trabajo del paciente"
          }}
        </p>
        <p style="text-align: end" class="textoSubtitulo">Cod_ODT_General</p>
      </div>

      <div class="d-flex justify-content-center mt-5" style="min-height: 6vh">
        <div
            v-for="(tab, index) in tabs"
            :key="index"
            style="border-bottom: 1px solid #ebebeb"
        >
          <div
              class="m-0 p-0 d-flex justify-content-center align-items-center flex-column"
              :class="{ selectedTab: tabIndexActivo === index }"
              style="height: 100%; width: 11vw ; cursor: pointer"
              @click="seleccionarEtapa(index, tab)"
          >
            <a
            ><p
                class="m-0 p-0 mb-2"
                :class="{ defaultTab: tabIndexActivo !== index }"
                v-if="tab.idEtapaProceso !== 108"
            >
              {{ tab.title }} ({{ tab.count ? tab.count : 0 }})
            </p>
              <p
                  class="m-0 p-0 mb-2"
                  :class="{ defaultTab: tabIndexActivo !== index }"
                  v-else
              >
                {{ tab.title }}
              </p></a
            >
            <hr v-if="tabIndexActivo === index" class="active-line" />
          </div>
        </div>
      </div>

      <b-row
          class="d-flex justify-content-between align-items-center"
          style="margin-top: 4em"
      >
        <b-col cols="5" class="d-flex justify-content-start w-100">
          <div class="barras d-flex w-100" v-if="tipoPantalla === 1">
            <b-form-input
                class="input-filter"
                v-model="nombrePaciente"
                placeholder="Búsqueda por nombre de paciente"
                @keydown.enter.prevent="buscarPaciente()"
                type="text"
            >
            </b-form-input>
            <b-button @click="buscarPaciente()" class="btn-extra-small" variant="info">
            <span
            ><em class="buscar_svg" style="margin-top: 3px; height: 13px"></em
            ></span>
            </b-button>
          </div>
          <div class="barras d-flex w-100" v-else>
            <b-form-input
                class="input-filter"
                v-model="filter"
                placeholder="Búsqueda por Tratamiento"
                type="text"
                @keydown.enter.prevent="buscarTratamiento()"
            >
            </b-form-input>
            <b-button @click="buscarTratamiento()" class="btn-extra-small" variant="info" pill>
          <span
          ><em
              class="buscar_svg"
              style="margin-top: 3px; height: 13px; border-radius: 20px"
          ></em
          ></span>
            </b-button>
          </div>
          <div style="margin-left: 6px" v-if="tipoPantalla !== 1">
            <b-button class="rounded-circle btn-dentalia">
              <em class="generar_odt_svg" style="scale: 1.3; position: absolute; top: 27%; left: 27%;"
                  v-b-tooltip.hover.top.v-light title="Generar nueva ODT"
                  @click="abrirModalOdt = true">
              </em>
            </b-button>
          </div>
        </b-col>
        <b-col cols="5">
          <div class="d-flex justify-content-between" style="font-size: 0.85em">
            <div class="d-flex align-items-center">
              <a
                  href="#"
                  id="popover-filtro-clinicas"
                  :class="
                filtros.clinica.length > 0
                  ? 'filtrosActivos'
                  : 'filtrosInactivos'
              "
                  @click.prevent
              >Clínica
                <span v-if="filtros.clinica.length > 0"
                >({{
                    filtros.clinica.length == 1
                        ? nombreClinicaSeleccionada
                        : filtros.clinica.length
                  }})</span
                >
                <em class="arrow_down_svg icon-chevron ml-1"></em
                ></a>
              <b-popover
                  target="popover-filtro-clinicas"
                  triggers="click blur"
                  placement="bottom"
              >
                <b-form-checkbox-group
                    v-model="filtros.clinica"
                    stacked
                    class="custom-checkbox-align"
                    style="width: 180px; overflow: auto; max-height: 200px"
                >
                  <b-form-checkbox
                      v-for="clinica in listaClinicas"
                      :key="clinica.idClinica"
                      :value="clinica.idClinica"
                  >
                    {{ clinica.nombreClinica }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
                <div class="text-center">
                  <b-button variant="outline-info" @click="filtrarFiltros" size="sm">Aplicar</b-button>
                </div>
              </b-popover>

            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center">
                <a
                    href="#"
                    id="popover-filtro-doctor"
                    :class="
                  filtros.doctor.length > 0
                    ? 'filtrosActivos'
                    : 'filtrosInactivos'
                "
                    @click.prevent
                >Doctor<span v-if="filtros.doctor.length > 0"
                >({{
                    filtros.doctor.length == 1
                        ? nombreDoctorSeleccionado
                        : filtros.doctor.length
                  }})</span
                >
                  <em class="arrow_down_svg icon-chevron ml-1"></em
                  ></a>
                <b-popover
                    target="popover-filtro-doctor"
                    triggers="click blur"
                    placement="bottom"
                >
                  <b-form-checkbox-group
                      stacked
                      v-model="filtros.doctor"
                      class="custom-checkbox-align"
                      style="width: 180px; overflow: auto; max-height: 200px"
                  >
                    <b-form-checkbox
                        v-for="doctor in listaDoctores"
                        :key="doctor.idEmpleado"
                        :value="doctor.idEmpleado"
                    >
                      <p class="mt-1">{{ doctor.nombreEmpleado }}</p>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                  <div class="text-center">
                    <b-button variant="outline-info" @click="filtrarFiltros" size="sm">Aplicar</b-button>
                  </div>
                </b-popover>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center">
                <a
                    href="#"
                    id="popover-filtro-lab"
                    :class="
                  filtros.laboratorio.length > 0
                    ? 'filtrosActivos'
                    : 'filtrosInactivos'
                "
                    @click.prevent
                >Laboratorio<span v-if="filtros.laboratorio.length > 0"
                >({{
                    filtros.laboratorio.length == 1
                        ? nombreLaboratorioSeleccionado
                        : filtros.laboratorio.length
                  }})</span
                >
                  <em class="arrow_down_svg icon-chevron ml-1"></em
                  ></a>
                <b-popover
                    target="popover-filtro-lab"
                    triggers="click blur"
                    placement="bottom"
                >
                  <b-form-checkbox-group
                      stacked
                      v-model="filtros.laboratorio"
                      class="custom-checkbox-align"
                      style="width: 180px; overflow: auto; max-height: 200px"
                  >
                    <b-form-checkbox
                        v-for="laboratorio in listaLaboratorios"
                        :key="laboratorio.idLaboratorio"
                        :value="laboratorio.idLaboratorio"
                    >
                      <p class="mt-1">{{ laboratorio.laboratorioNombre }}</p>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                  <div class="text-center">
                    <b-button variant="outline-info" @click="filtrarFiltros" size="sm">Aplicar</b-button>
                  </div>
                </b-popover>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center">
                <a
                    href="#"
                    id="popover-filtro-fecha"
                    :class="
                  mesPeriodo != null ? 'filtrosActivos' : 'filtrosInactivos'
                "
                    @click.prevent
                >Fecha <span>({{ nombreMesSeleccionado }} {{anioPeriodo}})</span>
                  <em class="arrow_down_svg icon-chevron ml-1"></em
                  ></a>
                <b-popover
                    target="popover-filtro-fecha"
                    triggers="click blur"
                    placement="bottom"
                >
                  <div class="p-2">
                    <b-form-group class="text-left">
                      <label for="selectMes">Mes</label>
                      <b-form-select
                          :options="listaMeses"
                          v-model="mesPeriodo"
                          text-field="nombreMes"
                          value-field="idMes"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group class="text-left">
                      <label for="selectAnio">Año</label>
                      <b-form-select :options="anios" v-model="anioPeriodo">
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="text-center">
                    <b-button
                        variant="outline-info"
                        @click="actualizarRangoFechas"
                        size="sm"
                    >Aplicar</b-button
                    >
                  </div>
                </b-popover>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center">
                <a
                    href="#"
                    id="popover-filtro-progress"
                    :class="
                  filtros.progreso.length > 0
                    ? 'filtrosActivos'
                    : 'filtrosInactivos'
                "
                    @click.prevent
                >Progreso<span v-if="filtros.progreso.length > 0"
                >({{
                    filtros.progreso.length == 1
                        ? nombreProgresoSeleccionado
                        : filtros.progreso.length
                  }})</span
                >
                  <em class="arrow_down_svg icon-chevron ml-1"></em
                  ></a>
                <b-popover
                    target="popover-filtro-progress"
                    triggers="click blur"
                    placement="bottom"
                >
                  <b-form-checkbox-group
                      stacked
                      v-model="filtros.progreso"
                      class="custom-checkbox-align"
                      style="width: 180px; overflow: auto; max-height: 200px"
                  >
                    <b-form-checkbox
                        v-for="progreso in listaProgreso"
                        :key="progreso.idProgreso"
                        :value="progreso.progreso"
                    >
                      <p class="mt-1">{{ progreso.nombreProgreso }}</p>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                  <div class="text-center">
                    <b-button variant="outline-info" @click="filtrarFiltros" size="sm">Aplicar</b-button>
                  </div>
                </b-popover>
              </div>
            </div>

<!--       Limpiar filtros       -->
            <b-button class="boton-agenda-inv" style="margin-left: 1%" variant="primary"
                      v-if="mostrarLimp"
                      v-b-tooltip.hover.topright.v-light
                      title="Limpiar filtros"
                      @click="limpiarFiltros()"
                     >
              <em class="close_x_svg icon-boton-agenda-11"></em>
            </b-button>
          </div>
        </b-col>
      </b-row>

      <div class="contenedorTablaSinColor mt-5">
        <b-table
            v-show="!loader"
            :key="paginaActual"
            style="font-size: 11px"
            responsive
            id="listaOdts"
            :items="listaOdts"
            :fields="headersTabla"
            :busy="loader"
            empty-text="No se encontraron resultados"
            show-empty
        >
          <template #cell(idOdt)="row">
            <div class="d-flex align-items-center" v-if="isCancelacionSolicitada(row.item)">
              <em class="exclamation icons-size"
                  v-b-tooltip.hover.topright.v-light
                  title="Cancelación solicitada" />
              <span>{{ row.item.idOdt }}</span>
            </div>
            <div v-else-if="row.item.idEtapaProceso == 108 && row.item.odtCancelada == true">
              <em class="close_x icons-size-16"
                  v-b-tooltip.hover.topright.v-light
                  title="Cancelada" />
              <span>{{ row.item.idOdt }}</span>
            </div>
            <div v-else>
              {{ row.item.idOdt }}
            </div>
          </template>

          <template #cell(tratamientoNombre)="row">
            <div style="display: inline-flex" v-if="isCancelacionSolicitada(row.item)">
              <p style="border-bottom: 1px solid red;">
                {{ row.item.tratamientoNombre }}
              </p>
            </div>
            <div v-else>
              {{ row.item.tratamientoNombre }}
            </div>
          </template>
          <template #cell(fechaSolicitud)="row">
            {{ row.item.fechaSolicitud | formatoFechaCorta }}
          </template>
          <template #cell(diente)="row">
            <div v-if="row.item.tratamientos.length < 2">
              {{ row.item.tratamientos[0].numeroDiente }}
            </div>
            <div
                v-else
                v-for=" (r, index) in row.item.tratamientos"
                :key="index+'ind'+r.idTratamientoProgramado"
            >
              {{ r.numeroDiente }},
            </div>
          </template>
          <template #cell(progreso)="row">
            <div v-if="!row.item.progreso && params.idEtapaProceso !== 103 && row.item.idEtapaProceso !== 103">
              <b-badge pill class="badge-entiempo">En tiempo</b-badge>
            </div>
            <div v-if="row.item.progreso && params.idEtapaProceso !== 103 && row.item.idEtapaProceso !== 103">
              <b-badge pill class="badge-retraso">Retrasado</b-badge>
            </div>
            <div v-if="params.idEtapaProceso === 103 || row.item.idEtapaProceso === 103">
              <span>En espera</span>
            </div>
          </template>
          <template #cell(fechaUltimaEtapa)="row">
            {{ row.item.fechaUltimaEtapa | formatoFechaCorta }}
          </template>
          <template #cell(acciones)="row">
            <div
                style="
              display: flex;
              width: 100%;
              justify-content: center;
              gap: 4px;
            "
            >
              <em
                  :id="'btn-ver-odt-' + row.index"
                  class="outline_blue_eye"
                  style="width: 20px; cursor: pointer"
                  @click="verOdt(row.item)"
              ></em>
              <b-tooltip
                  :target="'btn-ver-odt-' + row.index"
                  placement="left"
                  variant="light"
                  title="Ver ODT"
              />

            <em
                class="outline_paqueteria"
                style="width: 20px; cursor: pointer"
                @click="abrirModalEnvio(row.item)"
                v-if="
                  !row.item.flujoDigital &&
                  row.item.tienePaqueteria &&
                  (row.item.idPaqueteria == null ||
                    row.item.numeroGuia == null) &&
                  params.idEtapaProceso === 103
                "
                  :id="'btn-paqueteria-' + row.index"
              />
              <b-tooltip
                  v-if="
                  !row.item.flujoDigital &&
                  row.item.tienePaqueteria &&
                  (row.item.idPaqueteria == null ||
                    row.item.numeroGuia == null) &&
                  params.idEtapaProceso === 103
                "
                  :target="'btn-paqueteria-' + row.index"
                  placement="left"
                  variant="light"
                  title="Agregar info. de paquetería"
              />

            <em
                class="outline_paqueteria"
                style="width: 20px; cursor: pointer"
                @click="abrirModalEnvio(row.item)"
                v-if="
                  !row.item.flujoDigital &&
                  row.item.tieneRecoleccion &&
                  row.item.nombrePersonaRecolecta == null &&
                  row.item.idEtapaProceso === 103
                "
                  :id="'btn-recoleccion-' + row.index"
              />
              <b-tooltip
                  v-if="
                  !row.item.flujoDigital &&
                  row.item.tieneRecoleccion &&
                  row.item.nombrePersonaRecolecta == null &&
                  row.item.idEtapaProceso === 103
                "
                  :target="'btn-recoleccion-' + row.index"
                  placement="left"
                  variant="light"
                  title="Agregar info. de recolección"
              />
              <em
                  class="flechaIzquierda"
                  v-if="row.item.idEtapaProceso === 108 && Number(row.item.skuOdt) % 1 === 0 && !row.item.tieneHijasEnProceso && row.item.odtCancelada != true"
                  style="width: 20px; cursor: pointer"
                  @click="crearHija(row.item)"
                  :id="'btn-crear-hija-' + row.index"
              />
              <b-tooltip
                  v-if="tipoPantalla !== 1 && row.item.idEtapaProceso === 108"
                  :target="'btn-crear-hija-' + row.index"
                  placement="left"
                  variant="light"
                  title="Crear ODT a partir de esta"
              />

            </div>
          </template>
        </b-table>
        <b-spinner v-if="loader" variant="info"></b-spinner>
      </div>
      <b-pagination
          v-show="totalRegistros > perPage"
          v-model="paginaActual"
          :per-page="perPage"
          :total-rows="totalRegistros"
          align="center"
          size="sm"
          class="my-2"
      />
      <b-modal
          v-model="abrirModalHija"
          size="lg"
          hide-footer
          hide-header
          no-close-on-backdrop
          v-if="item !== null"
      >
        <div class="row">
          <div
              class="col-10 d-flex"
              style="color: #044169; margin-top: -4px; font-weight: 600; width: 90%"
          >
            <em class="odt" style="height: 60%; margin-top: 5px"></em>
            <span class="textSize ml-2" style="font-weight: 600; margin-top: 5px"
            >Crear ODT a partir de Otra</span
            >
          </div>
          <div class="col-2 text-right">
            <em
                class="close_equis_svg"
                style="width: 26%; cursor: pointer"
                @click="abrirModalHija = false"
                v-b-tooltip.hover.topright.v-light
                title="Cerrar"
            />
          </div>
        </div>
        <div class="mt-3">
        <span style="color: #62b6c2; font-weight: 500">
          Odt id {{ item.idOdt }} : {{ item.tratamientoNombre }}
        </span>

          <p class="mt-1" style="font-size: 12px">
            ¿Que tipo de odt deseas crear a partir de la odt id {{ item.idOdt }}
          </p>

          <b-row class="mt-3">
            <b-col >
              <v-select
                  id="idTipoODT"
                  label="nombre"
                  v-model="idTipoOdtHija"
                  :options="listaTipoOdtFiltrada"
                  required
                  placeholder="Selecciona el estado"
                  :reduce="(variable) => variable.idTipoOdt"
                  style="font-size: 11px"
                  :clearable="false"
                  @input="idTipoDevolucion = null"
              />
            </b-col>

            <b-col>
              <v-select
                  v-show="idTipoOdtHija === 3"
                  id="idTipoODT"
                  label="nombre"
                  v-model="idTipoDevolucion"
                  :options="listaTipoDevolucion"
                  required
                  placeholder="Selecciona el tipo de devolución"
                  :reduce="(variable) => variable.idDevolucion"
                  style="font-size: 11px"
                  :clearable="false"
              />
            </b-col>
          </b-row>

          <div class="text-center mt-4">
            <b-button
                variant="outline-ligth"
                pill
                size="sm"
                style="background: #1b81af; color: #ffffff"
                :disabled="
              (idTipoOdtHija === 3 && idTipoDevolucion === null) ||
              idTipoOdtHija === null
            "
                @click="crearOdtHija()"
            >
              <span>Continuar</span>
            </b-button>
            <b-button
                variant="outline-secondary"
                pill
                size="sm"
                class="ml-4"
                @click="abrirModalHija = false"
            >
              <span>Cancelar</span>
            </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal
          v-model="abrirModalOdt"
          size="lg"
          hide-footer
          hide-header
          no-close-on-backdrop
      >
        <div class="row">
          <div
              class="col-10 d-flex"
              style="color: #044169; margin-top: -4px; font-weight: 600; width: 90%"
          >
            <em class="odt" style="height: 60%; margin-top: 5px"></em>
            <span class="textSize ml-2" style="font-weight: 600; margin-top: 5px"
            >Crear nueva ODT</span
            >
          </div>
          <div class="col-2 text-right">
            <em
                class="close_equis_svg"
                style="width: 26%; cursor: pointer"
                @click="cerrarx()"
                v-b-tooltip.hover.topright.v-light
                title="Cerrar"
            />
          </div>
        </div>

      <div>
        <span style="font-size: 11px">¿Que tipo de odt desea crear? </span>
        <br />
        <br />
        <b-row>
          <b-col>
            <v-select
                id="idTipoODT"
                label="nombre"
                v-model="idTipoOdt"
                :options="listaTiposODT"
                required
                placeholder="Selecciona el estado"
                :reduce="(variable) => variable.idTipoOdt"
                :style= ' idTipoOdt == null || idTipoOdt == 1 ? "font-size: 11px; width: 80%" : "font-size: 11px" '
                :clearable="false"
                @input="idTipoOdtHija = null"
            />
          </b-col>
          <b-col v-if="idTipoOdt == 2">
            <v-select
                id="idTipoODT"
                label="nombre"
                v-model="idTipoOdtHija"
                :options="listaTiposODTHijas"
                required
                placeholder="Selecciona el estado"
                :reduce="(variable) => variable.idTipoOdt"
                style="font-size: 11px"
                :clearable="false"
                @input="idTipoDevolucion = null"
            />
          </b-col>
        </b-row>

        <v-select
            class="mt-3"
            v-show="idTipoOdtHija === 3 "
            id="idTipoODT"
            label="nombre"
            v-model="idTipoDevolucion"
            :options="listaTipoDevolucion"
            required
            placeholder="Selecciona el tipo de devolución"
            :reduce="(variable) => variable.idDevolucion"
            style="font-size: 11px; width: 48%"
            :clearable="false"
        />


        <br />
        <div class="text-center">
          <b-button
            variant="outline-primary"
            pill
            size="sm"
            @click="agregarNuevo()"
            :disabled="idTipoOdt === null || (idTipoOdt === 2 && idTipoOdtHija === null) "
          >
            <span>Continuar</span>
          </b-button>
        </div>
      </div>
      </b-modal>

      <b-modal
          v-model="modalEnvio"
          size="lg"
          hide-footer
          hide-header
          no-close-on-backdrop>
        <div style="display: flex;width: 100%;">
          <div class="d-flex align-items-center detalle-formulario">
            <label class="detalle-formulario-h1 ml-2"
                   style="font-size: 20px; font-weight: bolder !important; color: var(--color-dentalia) !important;" for="titulosModalEnvio">
              {{tituloModalEnvio}}
            </label>

          </div>
          <b-button class="button-dentalia-svg-4 mr-2" variant="primary"
                    @click="cerrarModal()">
            <em class="close_x_svg icon-dentalia-svg-0" style="height: 16px; "></em>
          </b-button>
        </div>
        <br>
        <EnvioRecoleccion v-if="paqueterias !== null" :datosOdt="odtAgregarEnvio" :paqueterias="paqueterias" :modalEnvio="true" @cerrarModal="cerrarModal"/>
      </b-modal>
    </div>
  </div>

</template>
<script>
import Header from "@/components/Header.vue";
import EnvioRecoleccion from "../OrdenTrabajoPaciente/EnvioRecoleccion.vue";
export default {
  name: "OdtsPaciente",
  components: {
    Header,
    EnvioRecoleccion,
  },
  props: {
    idPaciente: {
      type: Number,
      default: null,
    },
    sexo: {
      type: Number,
      default: null,
    },
    edad: {
      type: Number,
      default: null,
    },
    nombrePaciente: {
      type: String,
      default: null,
    },
    tipoPantalla: {
      type: Number,
      default: 1,
    },
    activeTabIndexPerfil: {
      type: Number,
      default: 0
    },
    subTabIndexPerfil: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    listaTiposODT: [
      { nombre: "Nueva", idTipoOdt: 1 },
      {
        nombre: "Subsecuente a partir de una nueva fuera del NSD",
        idTipoOdt: 2,
      },
    ],
    listaTipoDevolucion: [
      { nombre: "Garantia Laboratorio", idDevolucion: 1 },
      { nombre: "Garantia Dentalia", idDevolucion: 2 },
    ],
    idTipoOdt: null,
    idTipoOdtHija: null,
    idTipoDevolucion: 1,
    selectTab: 0,
    listaLabs: [],
    filter: null,
    nombrePaciente: null,
    mesPeriodo: null,
    anioPeriodo: null,

    perPage: 20,
    paginaActual: 1,
    totalRegistros: 0,

    params: {
      idLaboratorio: null,
      idEtapaProceso: null,
      idPaciente: null,
      fechaInicio: null,
      fechaFin: null,
    },

    headersTabla: null,
    abrirModalOdt: false,
    abrirModalHija: false,
    listaOdts: [],
    listaTiposODTHijas: [],
    tipoODT: null,
    item: null,
    loader: false,
    listaTipoOdtFiltrada: [],
    tabs: [
      {
        title: "En proceso",
        idEtapaProceso: null,
      },
      {
        title: "Rechazados",
        idEtapaProceso: 0,
        esRechazado: true,
      },
      {
        title: "En tránsito a lab",
        idEtapaProceso: 103,
      },
      {
        title: "Mesa de ingreso",
        idEtapaProceso: 104,
      },
      {
        title: "Calidad",
        idEtapaProceso: 105,
      },
      {
        title: "Producción",
        idEtapaProceso: 106,
      },
      {
        title: "Salida de producción",
        idEtapaProceso: 111,
      },
      {
        title: "Retorno a clínica",
        idEtapaProceso: 107,
      },
      {
        title: "Completados",
        idEtapaProceso: 108,
      },
    ],
    tabIndexActivo: 0,
    listaClinicas: [],
    listaDoctores: [],
    listaLaboratorios: [],
    listaProgreso: [
      {
        idProgreso: 0,
        progreso: false,
        nombreProgreso: "Retrasado",
      },
      {
        idProgreso: 1,
        progreso: true,
        nombreProgreso: "En tiempo",
      },
    ],
    filtros: {
      clinica: [],
      doctor: [],
      laboratorio: [],
      progreso: [],
      fechaInicio: null,
      fechaFin: null,
      paginaActual: null,
    },
    listaMeses: [
      {
        idMes: 1,
        nombreMes: "Enero",
      },
      {
        idMes: 2,
        nombreMes: "Febrero",
      },
      {
        idMes: 3,
        nombreMes: "Marzo",
      },
      {
        idMes: 4,
        nombreMes: "Abril",
      },
      {
        idMes: 5,
        nombreMes: "Mayo",
      },
      {
        idMes: 6,
        nombreMes: "Junio",
      },
      {
        idMes: 7,
        nombreMes: "Julio",
      },
      {
        idMes: 8,
        nombreMes: "Agosto",
      },
      {
        idMes: 9,
        nombreMes: "Septiembre",
      },
      {
        idMes: 10,
        nombreMes: "Octubre",
      },
      {
        idMes: 11,
        nombreMes: "Noviembre",
      },
      {
        idMes: 12,
        nombreMes: "Diciembre",
      },
    ],
    anios: [],
    paqueterias: [],
    modalEnvio: false,
    tituloModalEnvio: '',
    odtAgregarEnvio: null,
    mostrarLimp: false,
    etapaAnterior: null,
  }),
  mounted() {
    if (this.tipoPantalla === 1) {
      this.params.idEtapaProceso = null;
      this.params.idLaboratorio = null;
    }

    this.anios = this.generarListaAnios(2025, new Date().getFullYear());
    this.params = {
      idLaboratorio: null,
      idEtapaProceso: null,
      idPaciente: this.idPaciente ? this.idPaciente : null,
      fechaInicio: null,
      fechaFin: null,
    };

    this.headersTabla = this.generarHeaders(this.tipoPantalla);
    this.obtenerTipoODTSHijas();

    this.obtenerConteoOdts();
    this.obtenerTotalPaginas()

  },
  async created() {
    this.llenarAnios();
    this.obtenerPaqueterias();
    this.obtenerDatosFiltros();

    if (this.tipoPantalla == 1){
      this.filtros = this.$localStorageService.getFiltros() != null ? this.$localStorageService.getFiltros()
          : localStorage.setItem("filtros", JSON.stringify( this.filtros ));
    }else{
      this.filtros = this.$localStorageService.getFiltrosPerfil() != null ? this.$localStorageService.getFiltrosPerfil()
          : localStorage.setItem("filtrosPerfil", JSON.stringify( this.filtros ));


      this.filtros.idPaciente = this.idPaciente ? this.idPaciente : null;
      localStorage.setItem("filtrosPerfil", JSON.stringify( this.filtros ));
    }
    this.mostrarLimpiar();


    this.tabIndexActivo = this.$localStorageService.getTabIndexActivo() != null ?  this.$localStorageService.getTabIndexActivo() : 0 ;
    this.seleccionarEtapa(this.tabIndexActivo, this.tabs[this.tabIndexActivo])


  },
  watch: {
    paginaActual() {
      this.obtenerOdts(); // Solo carga la página actual, sin tocar totalRegistros
    }
  },
  computed: {
    nombreClinicaSeleccionada() {
      const clinica = this.listaClinicas.find(
        (c) => c.idClinica === this.filtros.clinica[0]
      );
      return clinica ? clinica.nombreClinica : "";
    },
    nombreDoctorSeleccionado() {
      const doctor = this.listaDoctores.find(
        (c) => c.idEmpleado === this.filtros.doctor[0]
      );
      return doctor ? doctor.nombreEmpleado : "";
    },
    nombreLaboratorioSeleccionado() {
      const lab = this.listaLaboratorios.find(
        (c) => c.idLaboratorio === this.filtros.laboratorio[0]
      );
      return lab ? lab.laboratorioNombre : "";
    },
    nombreProgresoSeleccionado() {
      const lab = this.listaProgreso.find(
        (c) => c.progreso === this.filtros.progreso[0]
      );
      return lab ? lab.nombreProgreso : "";
    },
    nombreMesSeleccionado() {
      const mes = this.listaMeses.find((c) => c.idMes === this.mesPeriodo);
      return mes ? mes.nombreMes : "";
    },

  },
  methods: {
    cerrarx(){
      this.idTipoOdt = null;
      this.idTipoOdtHija = null;
      this.idTipoDevolucion = 1;
      this.abrirModalOdt = false
    },
    buscarPaciente(){
      this.filtros.nombrePaciente = this.nombrePaciente;
      localStorage.setItem("filtros", JSON.stringify( this.filtros ));
      this.obtenerOdts();
    },
    buscarTratamiento(){
      this.filtros.nombreTratamiento = this.filter;
      localStorage.setItem("filtrosPerfil", JSON.stringify( this.filtros ));
      this.obtenerOdts();
    },
    limpiarFiltros(){
      if (this.tipoPantalla == 1 ){
        this.filtros = {
          clinica: [],
          doctor: [],
          laboratorio: [],
          progreso: [],
          fechaInicio: null,
          fechaFin: null,
          idEtapaProceso: this.filtros.idEtapaProceso,
          nombrePaciente: ''
        };
        localStorage.setItem("filtros", JSON.stringify( this.filtros ));
      }else {
        this.filtros = {
          clinica: [],
          doctor: [],
          laboratorio: [],
          progreso: [],
          fechaInicio: null,
          fechaFin: null,
          idEtapaProceso: this.filtros.idEtapaProceso,
          nombreTratamiento: '',
          idPaciente: this.idPaciente ? this.idPaciente : null,
        };
        localStorage.setItem("filtrosPerfil", JSON.stringify( this.filtros ));
      }

      this.mesPeriodo = null;
      this.anioPeriodo = null;
      this.mostrarLimpiar();
      this.obtenerTotalPaginas();
    },

    filtrarFiltros(){
      if (this.tipoPantalla == 1){
        localStorage.setItem("filtros", JSON.stringify( this.filtros ));
        this.mostrarLimpiar();
      } else {
        localStorage.setItem("filtrosPerfil", JSON.stringify( this.filtros ));
        this.mostrarLimpiar();
      }
      this.obtenerTotalPaginas();

    },

    mostrarLimpiar() {
      const datos = this.tipoPantalla == 1 ? this.$localStorageService.getFiltros() : this.$localStorageService.getFiltrosPerfil();

      for (let key in datos) {
        if (key === 'idPaciente') continue;
        if (key === 'idEtapaProceso') continue;

        const valor = datos[key];
        if (
            valor !== null &&
            valor !== '' &&
            (!Array.isArray(valor) || valor.length > 0)
        ) {
          this.mostrarLimp = true
          return true;
        }
      }
      this.mostrarLimp = false
      return false;
    },

    verOdt(item) {
      if (this.tipoPantalla !== 1) {
        this.$localStorageService.setActiveTabPacientePerfil(this.activeTabIndexPerfil)
        this.$localStorageService.setActiveSubTabPacientePerfil(this.subTabIndexPerfil)
      }

      this.$router.push({
        name: "detalleOdtPaciente",
        params: {
          idPaciente: item.idPaciente ? item.idPaciente : this.idPaciente,
          idOdt: item.idOdt,
          idSolicitud: item.idSolicitud,
          idSolicitudEtapa: item.idSolicitudEtapa,
          idEtapa: item.idEtapaProceso
        },
      });
    },
    obtenerDatos() {
      const diaInicio = 1;
      const diaFin = this.$moment()
        .month(this.mesPeriodo - 1)
        .daysInMonth();
      this.fcInicio = this.$moment([
        this.anioPeriodo,
        this.mesPeriodo - 1,
        diaInicio,
      ]);
      this.fcFin = this.$moment([
        this.anioPeriodo,
        this.mesPeriodo - 1,
        diaFin,
      ]);
    },
    llenarAnios() {
      let inicio = 2025;
      while (inicio <= new Date().getFullYear()) {
        this.anios.push(inicio);
        inicio++;
      }
    },

    obtenerTipoODTSHijas() {
      this.$http.get(this.$api + "labs/tipoODT").then((response) => {
        if (response.data.data) {
          const lista = response.data.data;
          this.listaTiposODTHijas = lista.filter((l) => l.idTipoOdt !== 1);
        }
      });
    },

     obtenerTotalPaginas(){
      this.totalRegistros = 0;
      this.loader = true;
      const params = {filtros: this.tipoPantalla == 1 ? this.$localStorageService.getFiltros() : this.$localStorageService.getFiltrosPerfil()}
      this.$http.post(this.$api + "labs/odt/totalRegistrosOdt", params).then((response) => {
        if (response.data.data) {
          this.totalRegistros = JSON.parse(JSON.stringify(response.data.data));
        }
      }).finally(()=>{
        this.obtenerOdts();
      })
    },

    obtenerOdts() {
      this.listaOdts = []
      const parametros = {
        filtros: this.tipoPantalla == 1 ? this.$localStorageService.getFiltros() : this.$localStorageService.getFiltrosPerfil(),
        paginaActual: this.paginaActual - 1,
      }
      this.loader = true;
      this.$http.post(this.$api + "labs/odt/obtenerOdtsPaciente", parametros).then((response) => {
        if (response.data.data) {
          this.listaOdts = JSON.parse(JSON.stringify( response.data.data )) ;



        }
      }).finally(() => {
        this.loader = false;
      });
    },
    crearHija(item) {
      this.abrirModalHija = true;
      this.item = item;
      if (item.tratamientos[0].aplicaAjuste){
        this.listaTipoOdtFiltrada = this.listaTiposODTHijas.filter((l) => l.idTipoOdt !== 1 );
      }else{
        this.listaTipoOdtFiltrada = this.listaTiposODTHijas.filter((l) => l.idTipoOdt !== 1 && l.idTipoOdt !== 2);
      }

    },
    crearOdtHija() {
      this.$router.push({
        name: "odenTrabajoPaciente",
        params: {
          idPaciente: this.idPaciente !== null ? this.idPaciente : this.item.idPaciente,
          sexo: this.sexo !== null ? this.sexo : this.item.idSexo !== null ? this.item.idSexo : 0,
          edad: this.edad ? this.edad : this.item.edad,
          nombrePaciente: this.nombrePaciente != null ? this.nombrePaciente : this.item.nombrePaciente,
          idOdt: this.item.idOdt,
          tipoOdt: this.idTipoOdtHija,
          origenOdt: 3,
          idSolicitud: this.item.idSolicitud,
        },
      });
    },
    agregarNuevo() {
      if (this.idTipoOdt !== null) {
        this.$router.push({
          name: "odenTrabajoPaciente",
          params: {
            idPaciente: this.idPaciente,
            sexo: this.sexo !== null ? this.sexo : 0,
            edad: this.edad,
            nombrePaciente: this.nombrePaciente,
            idOdt: 0,
           // tipoOdt: 1,
            tipoOdt: this.idTipoOdtHija != null ? this.idTipoOdtHija : 1,
            origenOdt: this.idTipoOdt,
            idSolicitud: 0,
          },
        });
      }
    },

    obtenerConteoOdts() {
      this.loader = true;
      this.$http
        .post(this.$api + "labs/odt/obtenerConteoOdts", this.params)
        .then((response) => {
          if (response.data.data) {
            const conteoListado = response.data.data;

            // Relación entre los títulos de los tabs y las claves del backend
            const titleKeyMap = {
              "En proceso": "enProceso",
              "Rechazados": "rechazadas",
              "En tránsito a lab": "enRecepcion",
              "Mesa de ingreso": "enMesaDeIngreso",
              "Calidad": "enCalidad",
              "Producción": "enProduccion",
              "Salida de producción": "enSalidaProduccion",
              "Retorno a clínica": "enRetornoClinica",
              // "En tránsito a lab" y "Retorno a clínica" no tienen datos aún
            };

            this.tabs = this.tabs.map((tab) => {
              const key = titleKeyMap[tab.title];
              return {
                ...tab,
                count: key ? conteoListado[key] || 0 : 0,
              };
            });
            this.loader = false;
          }
        });
    },

    seleccionarEtapa(index, tab) {
      this.tabIndexActivo = index;
      localStorage.setItem("tabIndexActivo", JSON.stringify( this.tabIndexActivo ));

      if (this.tipoPantalla == 1){
        this.filtros.idEtapaProceso = tab.idEtapaProceso;
        localStorage.setItem("filtros", JSON.stringify( this.filtros ));
      }else{
        this.filtros.idEtapaProceso = tab.idEtapaProceso;
        localStorage.setItem("filtrosPerfil", JSON.stringify( this.filtros ));
      }

      if (tab.idEtapaProceso === 0) {
        this.params.odtsRechazadas = true;
        this.params.idEtapaProceso = null;
      } else {
        this.params.odtsRechazadas = null;
        this.params.idEtapaProceso = tab.idEtapaProceso;
      }
      this.manipularColumnasByEstapa(tab.idEtapaProceso);
      this.obtenerTotalPaginas();
    },

    generarHeaders(tipoPantalla ) {
      let headersBase =
        tipoPantalla == 1
          ? [
              // headersTablaGeneral
              { key: "idOdt", label: "ID ODT", sortable: false },
              {
                key: "tratamientoNombre",
                label: "Tratamiento",
                sortable: false,
              },
              { key: "nombrePaciente", label: "Paciente", sortable: false },
              { key: "tipoOdt", label: "Tipo de ODT", sortable: false },
              { key: "diente", label: "OD", sortable: false },
              {
                key: "laboratorioNombre",
                label: "Laboratorio",
                sortable: false,
              },
              { key: "clinicaNombre", label: "Clínica", sortable: false },
              { key: "nombreEmpleado", label: "Doctor", sortable: false },
              { key: "tipoEnvio", label: "Tipo de envío", sortable: false },
              {
                key: "fechaSolicitud",
                label: "Fecha solicitud",
                sortable: false,
              },
              { key: "progreso", label: "Progreso", sortable: false },
              { key: "acciones", label: "Acciones", sortable: false },
            ]
          : [
              // headersTablaPaciente
              { key: "idOdt", label: "ID ODT", sortable: false },
              {
                key: "tratamientoNombre",
                label: "Tratamiento",
                sortable: false,
              },
              { key: "tipoOdt", label: "Tipo de ODT", sortable: false },
              { key: "diente", label: "OD", sortable: false },
              {
                key: "laboratorioNombre",
                label: "Laboratorio",
                sortable: false,
              },
              { key: "nombreEmpleado", label: "Doctor", sortable: false },
              { key: "tipoEnvio", label: "Tipo de envío", sortable: false },
              {
                key: "fechaSolicitud",
                label: "Fecha solicitud",
                sortable: false,
              },
              { key: "progreso", label: "Progreso", sortable: false },
              { key: "acciones", label: "Acciones", sortable: false },
            ];

      return headersBase;
    },

    manipularColumnasByEstapa(idEtapaProceso) {
      // Siempre limpiamos columnas especiales antes de agregar las correctas
      const columnasAEliminar = [
        "progreso",
        "fechaUltimaEtapa",
        "usuarioRechazo",
      ];
      this.headersTabla = this.headersTabla.filter(
        (col) => !columnasAEliminar.includes(col.key)
      );

      const indexAcciones = this.headersTabla.findIndex(
        (col) => col.key === "acciones"
      );

      if (idEtapaProceso === 0) {
        this.headersTabla.splice(
          indexAcciones,
          0,
          { key: "fechaUltimaEtapa", label: "Fecha Rechazo", sortable: false },
          { key: "usuarioRechazo", label: "Usuario Rechazó", sortable: false }
        );
      } else if (idEtapaProceso === 107) {
        this.headersTabla.splice(indexAcciones, 0, {
          key: "fechaUltimaEtapa",
          label: "Fecha de Producción",
          sortable: false,
        });
      } else if (idEtapaProceso === 108) {
        this.headersTabla.splice(indexAcciones, 0, {
          key: "fechaUltimaEtapa",
          label: "Fecha Entrega",
          sortable: false,
        });
      } else {
        // Por defecto, mostrar progreso
        this.headersTabla.splice(indexAcciones, 0, {
          key: "progreso",
          label: "Progreso",
          sortable: false,
        });
      }
    },

    obtenerDatosFiltros(){
      this.loader = true;
      this.$http.post(this.$api + "labs/odt/llenarFiltros", this.filtros).then((response) => {
        if (response.data.data) {
          this.obtenerFiltros(response.data.data);
        }
      });

    },

    obtenerFiltros(datos) {
      this.listaClinicas = [];
      this.listaDoctores = [];
      this.listaLaboratorios = [];

      // Usamos Sets temporales para evitar duplicados de manera más eficiente
      const clinicasUnicas = new Set();
      const laboratoriosUnicos = new Set();
      const doctoresUnicos = new Set();

      datos.forEach((item) => {
        // Filtro para clínicas (evitamos duplicados)
        const claveClinica = `${item.idClinica}-${item.clinicaNombre}`;
        if (!clinicasUnicas.has(claveClinica)) {
          clinicasUnicas.add(claveClinica);
          this.listaClinicas.push({
            idClinica: item.idClinica,
            nombreClinica: item.clinicaNombre,
          });
        }

        // Filtro para laboratorios (evitamos duplicados)
        const claveLaboratorio = `${item.idLaboratorio}-${item.laboratorioNombre}`;
        if (!laboratoriosUnicos.has(claveLaboratorio)) {
          laboratoriosUnicos.add(claveLaboratorio);
          this.listaLaboratorios.push({
            idLaboratorio: item.idLaboratorio,
            laboratorioNombre: item.laboratorioNombre,
          });
        }

        // Filtro para doctores (si existe nombreEmpleado en los datos)
        if (item.nombreEmpleado) {
          const claveDoctor = `${item.nombreEmpleado}`; // Podrías usar un ID si existe
          if (!doctoresUnicos.has(claveDoctor)) {
            doctoresUnicos.add(claveDoctor);
            this.listaDoctores.push({
              idEmpleado: item.idEmpleado,
              nombreEmpleado: item.nombreEmpleado,
              // Si hay un ID de empleado, inclúyelo: idEmpleado: item.idEmpleado
            });
          }
        }
      });
    },

    // Genera un array de años en un rango (ej. 2020-2027)
    generarListaAnios(inicio, fin) {
      const anios = [];
      for (let i = fin; i >= inicio; i--) {
        anios.push(i); // Orden descendente (2027, 2026... 2020)
      }
      return anios;
    },

    // Actualiza fechas al seleccionar mes/año
    actualizarRangoFechas() {
      if (!this.mesPeriodo || !this.anioPeriodo) return;

      // Fecha inicio: primer día del mes
      this.params.fechaInicio = `${this.anioPeriodo}-${String(
        this.mesPeriodo
      ).padStart(2, "0")}-01`;

      // Fecha fin: último día del mes
      const ultimoDia = new Date(
        this.anioPeriodo,
        this.mesPeriodo,
        0
      ).getDate();
      this.params.fechaFin = `${this.anioPeriodo}-${String(
        this.mesPeriodo
      ).padStart(2, "0")}-${ultimoDia}`;

      this.filtros.fechaInicio = this.params.fechaInicio
      this.filtros.fechaFin = this.params.fechaFin
      if (this.tipoPantalla === 1){
        localStorage.setItem("filtros", JSON.stringify( this.filtros ));
        this.mostrarLimpiar();
      } else {
        localStorage.setItem("filtrosPerfil", JSON.stringify( this.filtros ));
        this.mostrarLimpiar();
      }



      this.obtenerTotalPaginas();
    },

    abrirModalEnvio(item){
      this.odtAgregarEnvio = item;
      console.log("this.odtAgregarEnvio",this.odtAgregarEnvio)
      this.tituloModalEnvio = 'Agregar información de ' + this.odtAgregarEnvio.tipoEnvio;
      this.modalEnvio = true;
    },

    obtenerPaqueterias(){
      this.$http.post(this.$api + "labs/odt/obtenerPaqueterias").then(response => {
        if (response.data.data) {
          this.paqueterias = response.data.data;
        }
      })
    },

    cerrarModal(){
      this.odtAgregarEnvio = null;
      this.tituloModalEnvio = '';
      this.modalEnvio = false;
    },
    isCancelacionSolicitada(odt) {
      return [112, 113, 114].includes(Number(odt.idEtapaProceso));
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
  padding: 0;
}

.selectedTab {
  background-color: #f4fbff;
  color: #3d87b4;
  font-size: 0.9em;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}

.defaultTab {
  color: #afafaf !important;
  font-size: 0.9em;
}

.active-line {
  position: absolute;
  bottom: 0;
  height: 2px;
  background-color: #83bee8;
  width: 50%;
  border: none;
  margin: 0;
}

.barras {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  height: 6vh;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
  border-radius: 20px;
  cursor: pointer;
}

.icon-chevron {
  height: 0.7em;
}

.filtrosActivos {
  font-weight: 600;
  color: #0069a9 !important;
  font-size: 0.8em;
}

.custom-checkbox-align .custom-control-label {
  padding-top: 2px;
  line-height: 1.3;
}

.filtrosInactivos {
  color: #6f6f6f !important;
  font-size: 0.8em;
}

.tooltip.top {
  margin-top: -10px !important;
}

.badge-entiempo {
  background-color: #eaffea;
  padding: 7px;
  color: #26853f;
  font-weight: 600;
}

.badge-retraso {
  background-color: #fff8ea;
  padding: 7px;
  color: #e2c000;
  font-weight: 600;
}

.btn-dentalia, .btn-dentalia:hover {
  background-color: #1B81AF;
  border-color: #1B81AF;
  color: #fff;
  position: relative;
  width: 40px;
  height: 40px;
}

.icon-boton-agenda-11 {
  margin: auto;
  height: 10px;
  display: block;
  padding: 1px;
}

.boton-agenda-inv, .boton-agenda-inv:hover {
  border-radius: 50rem;
  color:  var(--color-icono);
  background-color: white;
  border-color: #D0D0D0FF;
  box-shadow: 2px 3px 4px #c4c4c4;
  padding: 5px;
}

.boton-agenda-inv:hover, .boton-agenda-inv:active {
  border-color: var(--color-icono);
}
</style>
